const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: 8,
    boxShadow: "none!important"
  }),
  table: {
    maxWidth: "100%"
  },
  heading: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "13pt",
    paddingTop: "30px",
    paddingBottom: "15px"
  },
  testText: {
    color: "black !important",
    fontSize: "12pt",
    textAlign: "center"
    // minWidth: "60px",
    // maxWidth: "60px"
  },
  mac_tableheader_first: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "12pt",
    textAlign: "right",
    width: "150px",
    paddingRight: "10px !important"
  },
  mac_tableheader: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "12pt",
    textAlign: "left",
    paddingLeft: "10px !important"
  },
  tableheader_first: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "12pt",
    textAlign: "left",
    width: "150px"
  },
  tableheader: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "12pt",
    textAlign: "center"
  },
  tableheaderlast: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "12pt",
    textAlign: "center"
  },
  tableheader_sub: {
    color: "black !important",
    fontSize: "12pt",
    //textAlign: "center",
    padding: "0px !important"
  },
  mac_tablecontent: {
    width: "320px",
    color: "black",
    fontSize: "12pt",
    textAlign: "right",
    paddingRight: "10px !important"
  },
  mac_tablecontent_right: {
    width: "320px",
    color: "black",
    fontSize: "12pt",
    textAlign: "left",
    paddingLeft: "10px !important"
  },
  copper_tablecontent_first: {
    width: "320px",
    color: "black",
    fontSize: "12pt",
    textAlign: "left",
    padding: "0 !important"
  },
  tablecontent: {
    color: "black",
    fontSize: "12pt",
    textAlign: "center"
  },
  tablecontent_first: {
    width: "320px",
    color: "black",
    fontSize: "12pt",
    textAlign: "left"
  },
  tablecontent_first_wide: {
    width: "530px",
    color: "black",
    fontSize: "12pt",
    textAlign: "left",
    padding: "0 !important"
  },
  error_tablecontent_first: {
    width: "320px",
    color: "red",
    fontSize: "12pt",
    textAlign: "left"
  },
  tablecontentlast: {
    //fontWeight: "bold",
    color: "black",
    fontSize: "12pt"
  },
  failState: {
    color: theme.palette.fail
  },
  passState: {
    color: theme.palette.success
  },
  div_table1: {
    paddingTop: 30
  },
  div_table2: {
    height: 300,
    overflow: "auto"
  },
  defaultText: {
    fontSize: "14px"
  },

  passedText: {
    color: "#4CAF50",
    fontSize: "14px"
  },
  failedText: {
    color: "#FF5252",
    fontSize: "14px"
  },
  totalGrid: {
    borderRight: "0.5px solid #D3D3D3",
    textAlign: "center"
  },
  totalGridLast: {
    textAlign: "center"
  },
  infoHead: {
    display: "flex",
    margin: "0 Auto",
    width: "80px"
  },
  pass: {
    margin: theme.spacing.unit,
    textAlign: "center"
  },
  table2: {
    overflow: "auto",
    height: 380
  },
  logo: {
    width: "auto",
    height: "50px",
    maxHeight: "50px",
    backgroundColor: "grey",
    border: "1px solid white",
    display: "inline-block",
    maxWidth: "300px"
  },
  polarity: {
    fontSize: "14px",
    paddingTop: "35px"
  },
  statusText: {
    paddingLeft: "10px"
  },
  infoText: {
    paddingTop: "2px"
  },
  tab: {
    width: "240px !important"
  },
  tabHeader: {
    paddingTop: "25px"
  },
  gridHeader: {
    paddingTop: "10px"
  },
  disclaimer: {
    paddingTop: "10px"
  },
  disclaimerGrid: {
    borderBottom: "0.5px solid #D3D3D3"
  },
  vtabHeaderFirst: {
    background: "#f2f2f2",
    padding: "15px 35px 15px 15px",
    border: "1px solid #ddd",
    textAlign: "left",
    width: "90px",
    fontWeight: "bold",
    color: "black !important",
    fontSize: "12pt"
  },
  vtabHeader: {
    background: "#f2f2f2",
    padding: "15px 35px 15px 35px",
    border: "1px solid #ddd",
    width: "75px",
    //textAlign: "center"
    fontWeight: "bold",
    color: "black !important",
    fontSize: "12pt"
  },
  vtabDataFirst: {
    border: "1px solid #ddd",
    padding: "15px 35px 15px 15px",
    textAlign: "left",
    fontSize: "12pt"
  },
  vtabData: {
    border: "1px solid #ddd",
    textAlign: "center",
    fontSize: "12pt"
  },
  vSetupTitle: {
    fontSize: "11pt",
    padding: "10px 0px 15px 0px"
  },
  vSetupText: {
    fontSize: "11pt",
    padding: "10px 0px 15px 60px"
  },
  vSetupDiv: {
    display: "flex"
  },
  VLeftGrid: {
    borderTop: "0.5px solid #D3D3D3"
  },
  radioGroup: {
    display: "block !important"
  },
  voltageGrid: {
    borderLeft: "0.5px solid #D3D3D3",
    borderColor: "black"
  },
  itabVoltageHeader: {
    //background: "#f2f2f2",
    padding: "15px 35px 15px 35px",
    border: "1px solid #ddd",
    width: "70px",
    textAlign: "center",
    fontWeight: "bold",
    color: "black !important",
    fontSize: "12pt"
  },
  itabVoltageData: {
    //background: "#f2f2f2",
    padding: "15px 35px 15px 35px",
    border: "1px solid #ddd",
    width: "70px",
    textAlign: "center",
    fontWeight: "normal !important",
    color: "black !important",
    fontSize: "12pt"
  },
  skew_row: {
    background: "#ddd"
  },
  discovery_col: {
    maxWidth: "30px",
    minWidth: "30px",
    textAlign: "center",
    padding: "0px !important"
  },
  discovery_col_header: {
    maxWidth: "30px",
    minWidth: "30px",
    textAlign: "center",
    padding: "0px !important",
    color: "black !important",
    fontWeight: "bold"
  },
  div_table2: {
    height: 300,
    overflow: "auto"
  },
  mac_heading: {
    maxHeight: "50px"
    //textAlign:'center'
  },
  tableheader_sub_vlan: {
    color: "black !important",
    fontSize: "12pt",
    textAlign: "center",
    whiteSpace: "nowrap"
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/common/results/views/stats/styles.js